// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "ExpressiveListContainer-module--bx--text-truncate--end--4biJ8";
export var bxTextTruncateFront = "ExpressiveListContainer-module--bx--text-truncate--front--y2yX8";
export var container = "ExpressiveListContainer-module--container--i63Ot";
export var content = "ExpressiveListContainer-module--content--KCoBY";
export var expressive_02 = "ExpressiveListContainer-module--expressive_02--Y0Qzs";
export var expressive_04 = "ExpressiveListContainer-module--expressive_04--50YRj";
export var text = "ExpressiveListContainer-module--text--VYYsp";
export var title = "ExpressiveListContainer-module--title--Wo1Nz";